import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import Input from '../../Components/Input_Basic';
import BasicButton from '../../Components/Button_Basic';
import FormGroup from '../../Components/Form_Group';
import GridModal from '../../Components/Modal_Grid';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';
/** Mui Import */
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

function Sm10040(props) {
    React.useEffect(() => {
        document.title = '출하지시';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '영업관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>출하지시</strong>" +
            '</h1>';
    }, []);
    let custCd = '';
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    const gridRef2 = React.useRef();
    const [modalToggle, setModalToggle] = React.useState(false);
    const [modalToggle1, setModalToggle1] = React.useState(false);
    const [modalToggle2, setModalToggle2] = React.useState(false);
    const [checkInputs, setCheckInputs] = React.useState({
        custCd: '',
        delivOrderDate: new Date(),
        itemQty: '',
        whCd: 'WH_MM_01',
    });
    const columnDefs = [
        // {
        //   field: "no",
        //   headerName: "No",
        //   minWidth: 110,
        //   headerCheckboxSelection: true,
        //   checkboxSelection: true,
        // },
        //상태
        {
            field: 'stusNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoSatusNm' && f.lanType === 'COL')[0].lanName
                    : '', //`진행상태
            minWidth: 100,
            cellRenderer: Commons.CustomHeaderRenderer,
            // cellStyle: { color: "red" },
        },
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 200,
        },
        //출하지시일자
        {
            field: 'delivOrderDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderDt' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 130,
        },
        //주문수량
        {
            field: 'itemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_OrderQty' && f.lanType === 'COL')[0].lanName
                    : '',

            cellStyle: { textAlign: 'right' },
            // aggFunc: "sum",
            minWidth: 100,
        },
        //출하지시수량
        {
            field: 'delivOrderQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkQty' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            // aggFunc: "sum",
            minWidth: 100,
        },
        //비고
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
            editable: false,
        },
        //출하지시번호
        {
            field: 'delivOrderNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
        },
        //주문번호
        {
            field: 'soNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //납기일
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //거래처코드
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
    ];
    const columnDefs2 = [
        //순번
        {
            field: 'no',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WkSeq' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        //출하일자
        {
            field: 'delivDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ShipmentDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },

        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 300,
        },
        //출하수량
        {
            field: 'delivQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ShipmentQuantity' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 120,
        },
        //주문잔량
        {
            field: 'delivOrderBackQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_OrderRemaining' && f.lanType === 'COL')[0].lanName
                    : '',

            cellStyle: { textAlign: 'right' },
            // aggFunc: "sum",
            minWidth: 120,
        },
        //현재재고
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CurrentStock' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            // aggFunc: "sum",
            minWidth: 130,
        },
        //생산수량
        {
            field: 'workQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WorkQty1' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            // aggFunc: "sum",
            minWidth: 130,
        },
        //비고
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
            editable: true,
        },
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //출하번호
        {
            field: 'delivNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
    ];
    const soNoColumnDef = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        //주문번호
        {
            field: 'soNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //납기일
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //납기번호
        {
            field: 'soDueNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },

        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 170,
        },

        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 300,
        },
        //수량
        {
            field: 'itemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            minWidth: 120,
        },
        //적요
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_RemarkDtl' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
            editable: true,
        },
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //거래처코드
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
    ];
    const lotColumnDef = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 50,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        //LOT No
        {
            field: 'lotNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //수량
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        //창고
        {
            field: 'whCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    const lotColumnDef1 = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 50,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        //LOT No
        {
            field: 'lotNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //출하일자
        {
            field: 'delivDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ShipmentDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //출하수량
        {
            field: 'delivQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ShipmentQuantity' && f.lanType === 'COL')[0].lanName
                    : '0',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 120,
        },
        //출하지시번호
        {
            field: 'delivOrderNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
        },
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    //자동선택 버튼 이벤트
    const LotModalGridSelection = (_ref) => {
        let whNm = '';
        //창고코드 창고명 변환
        switch (checkInputs.whCd) {
            case 'WH_MM_01':
                whNm = '[부산][B][생산][Production]';
                break;
            case 'WH_MM_02':
                whNm = '[서울][S][생산][Production]';
                break;
            case 'WH_MM_03':
                whNm = '[베트남][V][생산][Production]';
                break;
            case 'WH_MM_04':
                whNm = '[중국][생산]生產倉庫';
                break;
            default:
                whNm = '[부산][B][생산][Production]';
                break;
        }
        //필요한 수량이 몇개 인지 확인
        //변수 changeQty =  itemQty  changeQty는 그리드안 수량과 연산 작업을 위한 변수
        let changeQty = checkInputs.itemQty;
        _ref.current.api.forEachNode(function (node) {
            //변수 changeQty !=0
            if (parseInt(changeQty) > 0) {
                //선택한 창고랑 그리드 안 창고랑 같을시
                if (node.data.whCd == whNm) {
                    //그리드 안 수량이 0이 아닐때 0일때 체크안되게 하기위해
                    if (node.data.stockQty != 0) {
                        node.setSelected(true);
                        changeQty -= node.data.stockQty;
                    }
                }
            }
        });
    };
    //자동선택 버튼 이벤트
    const LotModalGridSelection1 = (_ref) => {
        let whNm = '';
        //창고코드 창고명 변환

        //필요한 수량이 몇개 인지 확인
        //변수 changeQty =  itemQty  changeQty는 그리드안 수량과 연산 작업을 위한 변수

        let changeQty = checkInputs.itemQty;
        _ref.current.api.forEachNode(function (node) {
            //변수 changeQty !=0
            if (parseInt(changeQty) > 0) {
                //그리드 안 수량이 0이 아닐때 0일때 체크안되게 하기위해
                if (node.data.delivQty != 0) {
                    node.setSelected(true);
                    changeQty -= node.data.delivQty;
                }
            }
        });
    };
    const autoSizeAll = (skipHeader) => {
        const allColumnIds = [];
        this.gridColumnApi.getColumns().forEach((column) => {
            allColumnIds.push(column.getId());
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, true);
    };
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '45%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                        }}
                    >
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px' }}
                            selected={props.inputs.startDate}
                            onChange={(e) => {
                                props.setInputs({
                                    ...props.inputs,
                                    startDate: e,
                                });
                            }}
                        />
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px' }}
                            selected={props.inputs.endDate}
                            onChange={(e) => {
                                props.setInputs({
                                    ...props.inputs,
                                    endDate: e,
                                });
                            }}
                        />
                        {/* <Input
              type={"text"}
              containerStyle={{ width: "120px" }}
              style={{ minWidth: "0px" }}
              value={props.inputs.searchInput}
              onChange={(e) => {
                props.setInputs({
                  ...props.inputs,
                  searchInput: e.target.value,
                });
              }}
              onClick={() => {}}
              onKeyDown={() => {}}
            /> */}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                        }}
                    >
                        <AuthGroupButton
                            pageName="SM10040"
                            target="G01"
                            refreshNone="none"
                            selectFunc={() => {
                                props.Init('not');
                            }}
                            addFunc={() => {
                                props.setOrderData([]);
                                props.setInputs({
                                    ...props.inputs,
                                    delivOrderNo: '',
                                    custCd: '',
                                    custNm: '',
                                });
                                setCheckInputs({
                                    ...checkInputs,
                                    custCd: '',
                                });
                                props.Init('not');
                                setModalToggle(true);
                            }}
                            deleteFunc={() => {
                                props.DeleteConfirm();
                            }}
                        />
                    </div>
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        defaultColDef={{
                            flex: 1,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        autoSizeAll={autoSizeAll}
                        onCellValueChanged={(e) => {}}
                        rowData={props.rowData}
                        rowSelection="multiple"
                        onSelectionChanged={() => {
                            GridFunctions.onSelectionChanged(gridRef, (e) => {
                                props.setInputs({
                                    ...props.inputs,
                                    delivOrderDt: e[0].delivOrderDt,
                                    delivOrderNo: e[0].delivOrderNo,
                                    custCd: e[0].custCd,
                                    custNm: e[0].custNm,
                                    itemCd: e[0].itemCd,
                                    delivOrderQty: e[0].delivOrderQty,
                                });
                                props.setCheckInputs({
                                    ...checkInputs,
                                    delivOrderNo: e[0] ? e[0].delivOrderNo : '',
                                    itemCd: e[0] ? e[0].itemCd : '',
                                });
                                props.setSelectedRowData(e);
                                if (e[0]) {
                                    props.GetDelivOrderItems(e[0].delivOrderNo, e[0].itemCd);
                                }
                            });
                        }}
                    />
                </div>
            </div>
            <div style={{ width: '55%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'end',
                    }}
                >
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Print' && f.lanType === 'BTN')[0].lanName
                                : '' //인쇄
                        }
                        onClick={() => props.Print(props.inputs.delivOrderNo, props.inputs.delivOrderDt)}
                    />
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Print1' && f.lanType === 'BTN')[0]
                                      .lanName
                                : '' //인쇄1
                        }
                        onClick={() => props.Print1(props.inputs.delivOrderNo, props.inputs.delivOrderDt)}
                    />
                    <AuthGroupButton
                        pageName="SM10040"
                        target="G03"
                        refreshNone="none"
                        saveFunc={() => {
                            if (!props.selectedRowData2 || props.selectedRowData2.length == 0) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: '항목을 선택하세요.',
                                });
                                return false;
                            } else {
                                props.SaveConfirm();
                            }
                        }}
                        addFunc={() => {
                            if (!props.selectedRowData) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: props.lanData.filter(
                                        (f) => f.lanId === 'Snack_SelectItemShip' && f.lanType === 'SNACK'
                                    )[0].lanName,
                                });
                                return false;
                            }
                            if (!props.selectedRowData[0].delivOrderNo) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: props.lanData.filter(
                                        (f) => f.lanId === 'Snack_SelectItemShip' && f.lanType === 'SNACK'
                                    )[0].lanName,
                                });
                                return false;
                            } else if (!props.selectedRowData[0].itemCd) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: props.lanData.filter(
                                        (f) => f.lanId === 'Snack_SelectItemShip' && f.lanType === 'SNACK'
                                    )[0].lanName,
                                });
                                return false;
                            } else if (props.selectedRowData.length < 1) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: props.lanData.filter(
                                        (f) => f.lanId === 'Snack_SelectItemShip' && f.lanType === 'SNACK'
                                    )[0].lanName,
                                });
                                return false;
                            } else {
                                setCheckInputs({
                                    ...checkInputs,
                                    delivOrderDate: new Date(),
                                    itemQty: '',
                                });
                                props.GetStockList();
                                setModalToggle1(true);
                            }
                        }}
                    />
                    <BasicButton
                        name={
                            //출하취소
                            props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Btn_ShipmentCancel' && f.lanType === 'BTN'
                                  )[0].lanName
                                : ''
                        }
                        onClick={(e) => {
                            if (props.selectedRowData2.length == 0) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: props.lanData.filter(
                                        (f) => f.lanId === 'Snack_SelectData' && f.lanType === 'SNACK'
                                    )[0].lanName,
                                });
                                return false;
                            } else if (!props.selectedRowData2[0].delivNo) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: props.lanData.filter(
                                        (f) => f.lanId === 'Snack_SelectItem' && f.lanType === 'SNACK'
                                    )[0].lanName,
                                });
                                return false;
                            } else if (!props.selectedRowData2[0].itemCd) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: props.lanData.filter(
                                        (f) => f.lanId === 'Snack_SelectItem' && f.lanType === 'SNACK'
                                    )[0].lanName,
                                });
                                return false;
                            } else if (props.selectedRowData2.length < 1) {
                                props.setSnackbars({
                                    toggle: true,
                                    type: 'info',
                                    message: props.lanData.filter(
                                        (f) => f.lanId === 'Snack_SelectItem' && f.lanType === 'SNACK'
                                    )[0].lanName,
                                });
                                return false;
                            } else {
                                setCheckInputs({
                                    ...checkInputs,
                                    delivOrderDate: new Date(),
                                    itemQty: '',
                                });
                                props.CancleDelivModal(
                                    props.selectedRowData[0].itemCd,
                                    props.selectedRowData2[0].delivNo,
                                    props.selectedRowData[0].soDueDt
                                );
                                setModalToggle2(true);
                            }
                        }}
                        // onClick={(e) => props.CancleDeliv()}
                    />
                </Card>
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '720px' }}>
                    <AgGridReact
                        ref={gridRef2}
                        animateRows={true}
                        columnDefs={columnDefs2}
                        groupIncludeTotalFooter={true}
                        defaultColDef={{
                            flex: 1,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        onCellValueChanged={(e) => {}}
                        rowData={props.rowData2}
                        rowSelection="multiple"
                        onSelectionChanged={() => {
                            GridFunctions.onSelectionChanged(gridRef2, (e) => {
                                props.setInputs({
                                    ...props.inputs,
                                    plantCd: e[0] ? e[0].plantCd : '',
                                    delivOrderNo: e[0] ? e[0].delivOrderNo : '',
                                    custCd: e[0] ? e[0].custCd : '',
                                    custNm: e[0] ? e[0].custNm : '',
                                    itemCd: e[0] ? e[0].itemCd : '',
                                    delivOrderQty: e[0] ? e[0].delivOrderQty : '',
                                    soDueDt: e[0] ? e[0].soDueDt : '',
                                });
                                props.setSelectedRowData2(e);
                            });
                        }}
                        getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                    />
                </div>
            </div>
            {/* 거래처별 품목 리스트 */}
            {modalToggle && (
                <GridModal
                    containerStyle={{ width: '1200px' }}
                    conditions={[
                        {
                            type: 'input',
                            style: { marginRight: '5px' },
                            labelStyle: {
                                marginRight: '0px',
                                paddingLeft: '0px',
                                width: '100px',
                                textAlign: 'center',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd/Nm' && f.lanType === 'COL')[0]
                                          .lanName
                                    : '',
                            value: props.paramsInputs.custCd,
                            onChange: (e) => {
                                props.setParamsInputs({
                                    ...props.paramsInputs,
                                    custCd: e.target.value,
                                });
                            },
                            onClick: (e) => {},
                            onKeyDown: (e) => {
                                props.GetOrders();
                            },
                        },
                        {
                            type: 'input',
                            style: { marginRight: '5px' },
                            labelStyle: {
                                marginRight: '0px',
                                paddingLeft: '0px',
                                width: '50px',
                                textAlign: 'center',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd/Nm' && f.lanType === 'COL')[0]
                                          .lanName
                                    : '',
                            value: props.paramsInputs.itemCd,
                            onChange: (e) => {
                                props.setParamsInputs({
                                    ...props.paramsInputs,
                                    itemCd: e.target.value,
                                });
                            },
                            onClick: (e) => {},
                            onKeyDown: (e) => {
                                props.GetOrders();
                            },
                        },
                        // {
                        //   type: "muicombo",
                        //   // 거래처
                        //   name:
                        //     props.lanData.length > 0
                        //       ? props.lanData.filter(
                        //           (f) => f.lanId === "Fom_CustNm" && f.lanType === "FORM"
                        //         )[0].lanName
                        //       : "",
                        //   combos: props.inputs.custList,
                        //   id: props.inputs.custList.id,
                        //   value: props.inputs.comboList,
                        //   onChange: (e) => {
                        //     props.inputs.custList.map((item, index) => {
                        //       if (
                        //         e.target.childNodes[0]
                        //           ? e.target.childNodes[0].nodeValue === item.label
                        //           : e.target.value === item.label
                        //       ) {
                        //         setCheckInputs({
                        //           ...checkInputs,
                        //           custCd: item.id,
                        //         });
                        //       }
                        //     });
                        //   },
                        //   onKeyUp: (event) => {
                        //     if (event.key === "Enter") {
                        //       return props.GetOrders(checkInputs.custCd);
                        //     }
                        //   },
                        //   renderInput: (params) => {
                        //     return (
                        //       <TextField
                        //         {...params}
                        //         label={"cust"}
                        //         InputProps={{
                        //           ...params.InputProps,
                        //           type: "search",
                        //         }}
                        //       />
                        //     );
                        //   },
                        // },

                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '',
                            onClick: (e) => {
                                props.GetOrders(checkInputs.custCd);
                            },
                        },
                        {
                            type: 'input',
                            style: { marginRight: '5px' },
                            labelStyle: {
                                marginRight: '0px',
                                paddingLeft: '0px',
                                width: '50px',
                                textAlign: 'center',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Col_Add_Item' && f.lanType === 'COL')[0]
                                          .lanName
                                    : '',
                            value: props.inputs.remark,
                            onChange: (e) => {
                                props.setInputs({
                                    ...props.inputs,
                                    remark: e.target.value,
                                });
                            },
                            onClick: (e) => {},
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Dia_CustItemList' && f.lanType === 'DIALOG')[0]
                                  .lanName
                            : ''
                    }
                    onClose={() => setModalToggle(false)}
                    gridColumn={soNoColumnDef}
                    gridRowData={props.orderData}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_CheckOK' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    gridRowSelection={'multiple'}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push(e[i]);
                        }
                        props.setSelectedModalData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        // props.ItemTied();

                        if (props.selectedModalData.length > 0) {
                            props.CreateDelivOrder();
                        }
                    }}
                />
            )}
            {/* 품목별 Lot리스트 */}
            {modalToggle1 && (
                <GridModal
                    conditions={[
                        {
                            type: 'dates',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ShipmentDate' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '',
                            selected: checkInputs.delivOrderDate,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    delivOrderDate: e,
                                });
                            },
                        },
                        {
                            type: 'combo',
                            //창고코드
                            // name:
                            //   props.lanData.length > 0
                            //     ? props.lanData.filter(
                            //         (f) =>
                            //           f.lanId === "Fom_ItemTypeNm" && f.lanType === "FORM"
                            //       )[0].lanName
                            //     : "",
                            combos: props.inputs.comboList,
                            value: checkInputs.whCd,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    whCd: e,
                                });
                            },
                        },
                        //수량
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Dia_Number' && f.lanType === 'DIALOG')[0]
                                          .lanName
                                    : '',
                            value: checkInputs.itemQty,
                            onChange: (e, ref) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    itemQty: e.target.value,
                                });
                                ref.current.api.forEachNode(function (node) {
                                    node.setSelected(false);
                                });
                            },
                            onClick: (e) => {},
                            onKeyDown: (e, ref) => {
                                LotModalGridSelection(ref);
                            },
                            inputType: 'number',
                        },
                        //자동선택
                        {
                            type: 'button',
                            style: {
                                width: '120px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Btn_AutomaticSelection' && f.lanType === 'BTN'
                                      )[0].lanName
                                    : '',
                            onClick: (e, ref) => {
                                LotModalGridSelection(ref);
                            },
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Dia_LotListItem' && f.lanType === 'DIALOG')[0]
                                  .lanName
                            : ''
                    }
                    onClose={() => setModalToggle1(false)}
                    gridColumn={lotColumnDef}
                    gridRowData={props.stockData}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Shipment' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    gridRowSelection={'multiple'}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push(e[i]);
                        }
                        props.setSelectedModalData1(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        props.CreateDeliv(new Date(checkInputs.delivOrderDate));
                    }}
                />
            )}
            {/* 품목별 Lot리스트 */}
            {modalToggle2 && (
                <GridModal
                    conditions={[
                        {
                            type: 'dates',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ShipmentDate' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '',
                            selected: checkInputs.delivOrderDate,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    delivOrderDate: e,
                                });
                            },
                        },

                        //수량
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Dia_Number' && f.lanType === 'DIALOG')[0]
                                          .lanName
                                    : '',
                            value: checkInputs.itemQty,
                            onChange: (e, ref) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    itemQty: e.target.value,
                                });
                                ref.current.api.forEachNode(function (node) {
                                    node.setSelected(false);
                                });
                            },
                            onClick: (e) => {},
                            onKeyDown: (e, ref) => {
                                LotModalGridSelection1(ref);
                            },
                            inputType: 'number',
                        },
                        //자동선택
                        {
                            type: 'button',
                            style: {
                                width: '120px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Btn_AutomaticSelection' && f.lanType === 'BTN'
                                      )[0].lanName
                                    : '',
                            onClick: (e, ref) => {
                                LotModalGridSelection1(ref);
                            },
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Dia_LotListItem' && f.lanType === 'DIALOG')[0]
                                  .lanName
                            : ''
                    }
                    onClose={() => setModalToggle2(false)}
                    gridColumn={lotColumnDef1}
                    gridRowData={props.cancleStockData}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_ShipmentCancel' && f.lanType === 'BTN')[0]
                                  .lanName
                            : ''
                    }
                    gridRowSelection={'multiple'}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push(e[i]);
                        }
                        props.setSelectedModalData2(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        props.CancleDeliv();
                    }}
                />
            )}
        </div>
    );
}

export default Sm10040;
